/**
 * URL 形式の入口検証ユーティリティ。
 *
 * ユーザー入力の URL をサーバーへ送る前にフロント側で弾くための述語。
 * サーバー側 schema の `z.url()` と対を成すが、より狭く http/https のみを許可し、
 * `javascript:` / `ftp:` 等のスキームや URL でない文字列を拒否する。
 */

/**
 * 入力値が http/https の URL 形式かを判定する。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business ユーザー入力 URL が http/https 形式かを判定する入口検証述語
 * @graph-connects none
 */
export function isHttpUrl(value: string): boolean {
  if (!URL.canParse(value)) {
    return false;
  }
  const url = new URL(value);
  return url.protocol === 'http:' || url.protocol === 'https:';
}
